import Lexical, {$isParagraphNode, $isRootNode, $isTextNode} from "lexical";

export class LexicalUtil {

    static readonly FORMAT_NONE = 0;
    static readonly ELEMENT_FORMAT_TYPE_NONE = '' as const;
    static readonly IS_BOLD = 1 /* Lexical.IS_BOLD */;
    static readonly IS_ALIGN_LEFT = 1/* Lexical.IS_ALIGN_LEFT */;
    static readonly IS_ALIGN_CENTER = 2/* Lexical.IS_ALIGN_CENTER */;
    static readonly IS_ALIGN_RIGHT = 3/* Lexical.IS_ALIGN_RIGHT */;

    static extractTextNodes(editor_state: Lexical.EditorState): Lexical.TextNode[] {
        return Array.from(editor_state._nodeMap.values()).filter((node): node is Lexical.TextNode => $isTextNode(node));
    }

    static extractParagraphNodes(editor_state: Lexical.EditorState): Lexical.ParagraphNode[] {
        return Array.from(editor_state._nodeMap.values()).filter((node): node is Lexical.ParagraphNode => !$isRootNode(node) && $isParagraphNode(node));
    }

    static textNodeStyleToMap(node: any): Map<string, string> {
        const style = node.__style;
        if (typeof style !== 'string') {
            throw new Error('unexpected node.__style');
        }

        const m = style.split(';').map(nv => nv.split(': ', 2)).filter(nv => nv.length === 2) as [string, string][];
        return new Map(m);
    }

    static interceptPendingEditorState(update_fn: () => void, editor?: Lexical.LexicalEditor): Lexical.EditorState {

        let editor_state = null;

        const target_editor = (editor === undefined) ? Lexical.createEditor() : editor;

        target_editor.update(() => {
            update_fn();
            editor_state = target_editor._pendingEditorState;
        });

        if (editor_state === null) {
            throw new Error("");
        }

        return editor_state;
    }

}
